// ----------------------------
// Created by Bulletproof Games
//            2016
//  www.bulletproofgames.co.uk
// ----------------------------
//
// Winline Animation Controller
//
// This class coordinates showing winlines and animating symbols

winlineAnimationController = undefined;

DUwinlineAnimationControllerFactory = {};
DUwinlineAnimationControllerFactory.winlineAnimationControllers = [];

DUwinlineAnimationControllerFactory.create = function () {
  var newWinlineAnimationController = {};
  newWinlineAnimationController.skip = false;
  newWinlineAnimationController.state = 'IDLE';
  newWinlineAnimationController.isAnimating = false;

  newWinlineAnimationController.initialise = function (config) {
    if (typeof resourceManager.getConfiguration().controllers === 'undefined') {
      console.error('No controllers section was found in config.json');
      return;
    }

    var invalid = 0;

    // Check winline animation controller and batcher exist
    invalid += checkForUndefined(config, 'config.winlineAnimationController was not found in config.json', true);
    invalid += checkForUndefined(config.batcher, 'batcher not found for winlineAnimationController', true);

    // Check winline and symbol animators exist
    invalid += checkForUndefined(
      config.symbolAnimator,
      'symbolAnimator not found for winlineAnimationController',
      true
    );
    invalid += checkForUndefined(
      config.winlineAnimator,
      'winlineAnimator not found for winlineAnimationController',
      true
    );

    // Check slot machine is defined
    invalid += checkForUndefined(config.slotMachine, 'slotMachine not defined for winlineAnimationController', true);

    // Did we encounter an error?
    if (invalid > 0) {
      return;
    }

    // Store which slot machine we are using
    var slotMachine = resourceManager.getController(config.slotMachine);
    if (checkForUndefined(slotMachine)) {
      console.error(
        'Slot machine ' +
          config.slotMachine +
          ' has not been defined or created. Slot machine must be created before winline animation controller in config.json'
      );
      return;
    }

    newWinlineAnimationController.slotMachine = slotMachineFactory.getSlotMachine(
      checkForDefined(config.slotMachine) ? config.slotMachine : 0
    );

    // Store the plugins we need to coordinate
    newWinlineAnimationController.winlineBatcher = resourceManager.getPlugin(config.batcher);
    newWinlineAnimationController.winlineBatcher.setUseWildSymbolAnim(
      checkForUndefined(
        config.useWildSymbolAnim,
        'useWildSymbolAnim property not found for winlineAnimationController, default of FALSE will be used',
        false
      )
        ? false
        : config.useWildSymbolAnim
    );
    newWinlineAnimationController.symbolAnimator = resourceManager.getPlugin(config.symbolAnimator);
    newWinlineAnimationController.winlineAnimator = resourceManager.getPlugin(config.winlineAnimator);

    invalid = 0;

    // Check batcher, winline and symbol animators have the correct functions defined
    invalid += checkForUndefined(
      newWinlineAnimationController.winlineBatcher.batch,
      'batch function not found for winlineBatcher ' + config.winlineBatcher,
      true
    );
    invalid += checkForUndefined(
      newWinlineAnimationController.symbolAnimator.playAnimation,
      'playAnimation function not found for symbolAnimator ' + config.symbolAnimator,
      true
    );
    invalid += checkForUndefined(
      newWinlineAnimationController.winlineAnimator.playAnimation,
      'playAnimation function not found for winlineAnimator ' + config.winlineAnimator,
      true
    );
    invalid += checkForUndefined(
      newWinlineAnimationController.symbolAnimator.skipAnimation,
      'skipAnimation function not found for symbolAnimator ' + config.symbolAnimator,
      true
    );
    invalid += checkForUndefined(
      newWinlineAnimationController.winlineAnimator.skipAnimation,
      'skipAnimation function not found for winlineAnimator ' + config.winlineAnimator,
      true
    );

    // Did we encounter an error?
    if (invalid > 0) {
      return;
    }
  };

  newWinlineAnimationController.resume = function () {
    // This is called when pauseAfterWinlineAnimation or pauseAfterSymbolAnimation are true
    // NOTE: This is called after EACH winline animation and EACH symbol animation.
    // e.g. 3 winline would require three "resumes" (one for each winline).
    if (newWinlineAnimationController.playNextAnimation() === false) {
      // All animations complete
      newWinlineAnimationController.isAnimating = false;
      newWinlineAnimationController.completeCallback();
    }
  };

  newWinlineAnimationController.startWinlineAnimations = function (
    winData,
    completeCallback,
    showingWinlineAnimationCallback,
    showingSymbolAnimationCallback,
    hidingWinlineAnimationCallback,
    hidingSymbolAnimationCallback,
    maxWinlineAnimationTime,
    pauseAfterWinlineAnimation,
    pauseAfterSymbolAnimation
  ) {
    // Check for undefined data
    if (checkForUndefined(winData, 'winData in winlineAnimationController.startWinlineAnimations is undefined', true))
      return;
    if (
      checkForUndefined(
        completeCallback,
        'completeCallback in winlineAnimationController.startWinlineAnimations is undefined',
        true
      )
    )
      return;

    newWinlineAnimationController.isAnimating = true;

    // First get the batcher to change winline data into winline animation sequence
    newWinlineAnimationController.sequenceData = newWinlineAnimationController.winlineBatcher.batch(
      winData,
      newWinlineAnimationController.name,
      newWinlineAnimationController.slotMachine,
      newWinlineAnimationController.paylines
    );
    newWinlineAnimationController.completeCallback = completeCallback;
    newWinlineAnimationController.skip = false;
    newWinlineAnimationController.showingWinlineAnimationCallback = checkForDefined(showingWinlineAnimationCallback)
      ? showingWinlineAnimationCallback
      : function () {};
    newWinlineAnimationController.showingSymbolAnimationCallback = checkForDefined(showingSymbolAnimationCallback)
      ? showingSymbolAnimationCallback
      : function () {};
    newWinlineAnimationController.hidingWinlineAnimationCallback = checkForDefined(hidingWinlineAnimationCallback)
      ? hidingWinlineAnimationCallback
      : function () {};
    newWinlineAnimationController.hidingSymbolAnimationCallback = checkForDefined(hidingSymbolAnimationCallback)
      ? hidingSymbolAnimationCallback
      : function () {};
    newWinlineAnimationController.maxWinlineAnimationTime = maxWinlineAnimationTime;

    // Pause after winline or symbol animation flags. winlineAnimationManager.resume() must be called to continue animations
    newWinlineAnimationController.pauseAfterWinlineAnimation = checkForDefined(pauseAfterWinlineAnimation)
      ? pauseAfterWinlineAnimation
      : false;
    newWinlineAnimationController.pauseAfterSymbolAnimation = checkForDefined(pauseAfterSymbolAnimation)
      ? pauseAfterSymbolAnimation
      : false;

    // Kick off animation process
    newWinlineAnimationController.currentAnimationIndex = 0;
    newWinlineAnimationController.playNextAnimation();
  };

  newWinlineAnimationController.skipAnimations = function () {
    if (!newWinlineAnimationController.sequenceData) return;

    var seq = newWinlineAnimationController.sequenceData[newWinlineAnimationController.currentAnimationIndex];
    if (!seq) return;

    newWinlineAnimationController.skip = true;

    switch (seq.type) {
      case 'Winline':
        {
          newWinlineAnimationController.winlineAnimator.skipAnimation(seq);
        }
        break;

      case 'Symbol':
        {
          newWinlineAnimationController.symbolAnimator.skipAnimation(seq);
        }
        break;

      case 'WinlineAndSymbol':
        {
          newWinlineAnimationController.winlineAnimator.skipAnimation(seq);
          newWinlineAnimationController.symbolAnimator.skipAnimation(seq);
        }
        break;

      default:
        {
          console.error("Winline Animation Controller encountered an unknown animation type '" + seq.type + "'");
        }
        break;
    }
  };

  newWinlineAnimationController.playNextAnimation = function () {
    // Returns true is there is another animation to play, and we are not skipping
    if (
      newWinlineAnimationController.skip ||
      newWinlineAnimationController.sequenceData.length === newWinlineAnimationController.currentAnimationIndex
    ) {
      return false;
    }

    newWinlineAnimationController.animationComplete = false;
    newWinlineAnimationController.state = 'PLAYING_ANIMATION';

    var seq = newWinlineAnimationController.sequenceData[newWinlineAnimationController.currentAnimationIndex];

    var remainingWinlineAnimations = 0;
    var remainingSymbolAnimations = 0;
    for (
      var i = newWinlineAnimationController.currentAnimationIndex;
      i < newWinlineAnimationController.sequenceData.length;
      i++
    ) {
      if (remainingSymbolAnimations === 0 && newWinlineAnimationController.sequenceData[i].type !== 'Symbol')
        remainingWinlineAnimations++;
      if (newWinlineAnimationController.sequenceData[i].type !== 'Winline') remainingSymbolAnimations++;
    }

    switch (seq.type) {
      case 'Winline':
        {
          newWinlineAnimationController.animationsPlaying = 1;
          newWinlineAnimationController.showingWinlineAnimationCallback(
            seq.data,
            remainingWinlineAnimations,
            remainingSymbolAnimations
          );
          newWinlineAnimationController.winlineAnimator.playAnimation(
            seq,
            newWinlineAnimationController.animationCompleteCallback,
            newWinlineAnimationController.maxWinlineAnimationTime
          );
        }
        break;

      case 'Symbol':
        {
          newWinlineAnimationController.animationsPlaying = 1;
          newWinlineAnimationController.showingSymbolAnimationCallback(seq.data, remainingSymbolAnimations);
          newWinlineAnimationController.symbolAnimator.playAnimation(
            seq,
            newWinlineAnimationController.animationCompleteCallback
          );
        }
        break;

      case 'WinlineAndSymbol':
        {
          newWinlineAnimationController.animationsPlaying = 2;
          newWinlineAnimationController.showingWinlineAnimationCallback(
            seq.data,
            remainingWinlineAnimations,
            remainingSymbolAnimations
          );
          newWinlineAnimationController.showingSymbolAnimationCallback(seq.data, remainingSymbolAnimations);
          newWinlineAnimationController.winlineAnimator.playAnimation(
            seq,
            newWinlineAnimationController.animationCompleteCallback,
            newWinlineAnimationController.maxWinlineAnimationTime
          );
          newWinlineAnimationController.symbolAnimator.playAnimation(
            seq,
            newWinlineAnimationController.animationCompleteCallback
          );
        }
        break;

      default:
        {
          console.error("Winline Animation Controller encountered an unknown animation type '" + seq.type + "'");
        }
        break;
    }

    return true;
  };

  newWinlineAnimationController.animationCompleteCallback = function () {
    if (--newWinlineAnimationController.animationsPlaying === 0) {
      var seq = newWinlineAnimationController.sequenceData[newWinlineAnimationController.currentAnimationIndex];
      newWinlineAnimationController.currentAnimationIndex++;

      var remainingWinlineAnimations = 0;
      var remainingSymbolAnimations = 0;
      for (
        var i = newWinlineAnimationController.currentAnimationIndex;
        i < newWinlineAnimationController.sequenceData.length;
        i++
      ) {
        if (remainingSymbolAnimations === 0 && newWinlineAnimationController.sequenceData[i].type !== 'Symbol')
          remainingWinlineAnimations++;
        if (newWinlineAnimationController.sequenceData[i].type !== 'Winline') remainingSymbolAnimations++;
      }

      switch (seq.type) {
        case 'Winline':
          {
            newWinlineAnimationController.hidingWinlineAnimationCallback(
              seq.data,
              remainingWinlineAnimations,
              remainingSymbolAnimations
            );
          }
          break;

        case 'Symbol':
          {
            newWinlineAnimationController.hidingSymbolAnimationCallback(seq.data, remainingSymbolAnimations);
          }
          break;

        case 'WinlineAndSymbol':
          {
            newWinlineAnimationController.hidingWinlineAnimationCallback(
              seq.dataremainingWinlineAnimations,
              remainingSymbolAnimations
            );
            newWinlineAnimationController.hidingSymbolAnimationCallback(seq.data, remainingSymbolAnimations);
          }
          break;
      }

      if (
        (seq.type === 'Winline' && newWinlineAnimationController.pauseAfterWinlineAnimation) ||
        (seq.type === 'Symbol' && newWinlineAnimationController.pauseAfterSymbolAnimation)
      ) {
        // Here we have a contract with the game to stop animations until newWinlineAnimationController.resume is called
        return;
      }

      if (newWinlineAnimationController.playNextAnimation() === false) {
        // All animations complete
        newWinlineAnimationController.isAnimating = false;
        newWinlineAnimationController.completeCallback();
      }
    }
  };

  newWinlineAnimationController.clearAnimations = function (callback) {
    newWinlineAnimationController.symbolAnimator.clearAnimations(callback);
  };

  DUwinlineAnimationControllerFactory.winlineAnimationControllers.push(newWinlineAnimationController);

  // For backwards compatibility
  if (DUwinlineAnimationControllerFactory.winlineAnimationControllers.length === 1) {
    winlineAnimationController = newWinlineAnimationController;
  }

  return newWinlineAnimationController;
};

resourceManager.registerController('DUwinlineAnimationController', DUwinlineAnimationControllerFactory.create);
